import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { getSelectableEmployees } from "actions/employeesActions";
import * as expensesActions from "actions/expensesActions";
import { expensesService, expStatus } from "services";
import Loading from "components/Loading";
import MobileExpenseNewSheet from "components/Expenses/Mobile/MobileExpenseNewSheet";

const MobileExpenseFormPage = () => {
	const dispatch = useDispatch();
	const history = useHistory();
	const location = useLocation();
	const { expenseId } = useParams();

	const isNew = !expenseId;
	const returnTo = location.state?.returnTo || "/expenses";

	const {
		expense_types,
		expense_groupings,
		providers,
		payment_types,
	} = useSelector((state) => state.expensesReducer);

	const [expense, setExpense] = useState(location.state?.expense ?? null);
	const [disabled, setDisabled] = useState(
		location.state?.disabled ?? false
	);
	const [loadingExpense, setLoadingExpense] = useState(
		!isNew && !location.state?.expense
	);
	const [loadingCatalog, setLoadingCatalog] = useState(true);

	const handleClose = useCallback(() => {
		history.push(returnTo);
	}, [history, returnTo]);

	const handleSaved = useCallback(() => {
		history.replace(returnTo, { refreshExpenses: true });
	}, [history, returnTo]);

	useEffect(() => {
		let cancelled = false;

		const loadCatalog = async () => {
			setLoadingCatalog(true);
			await Promise.all([
				dispatch(expensesActions.getAllExpenseTypes()),
				dispatch(expensesActions.getAllExpenseGroupings()),
				dispatch(expensesActions.getAllPaymentTypes()),
				dispatch(expensesActions.getAllProviders()),
				dispatch(expensesActions.getAllExpenseStatus()),
				dispatch(getSelectableEmployees()),
			]);
			if (!cancelled) setLoadingCatalog(false);
		};

		loadCatalog();
		return () => {
			cancelled = true;
		};
	}, [dispatch]);

	useEffect(() => {
		if (isNew) {
			setExpense(null);
			setDisabled(false);
			setLoadingExpense(false);
			return undefined;
		}

		if (location.state?.expense) {
			const fromList = location.state.expense;
			setExpense(fromList);
			setDisabled(
				location.state.disabled ?? fromList.status !== expStatus.pending
			);
			setLoadingExpense(false);
			return undefined;
		}

		let cancelled = false;

		const loadExpense = async () => {
			setLoadingExpense(true);
			const response = await expensesService.getById(expenseId);
			if (cancelled) return;

			if (response.ok) {
				setExpense(response);
				setDisabled(response.status !== expStatus.pending);
			} else {
				history.replace(returnTo);
			}
			setLoadingExpense(false);
		};

		loadExpense();
		return () => {
			cancelled = true;
		};
	}, [expenseId, isNew, history, returnTo, location.state]);

	if (loadingCatalog || loadingExpense) {
		return (
			<div className="mobile-expense-form-page__loading">
				<Loading />
			</div>
		);
	}

	return (
		<MobileExpenseNewSheet
			fullPage
			open
			expense={isNew ? null : expense}
			disabled={disabled}
			onClose={handleClose}
			onSaved={handleSaved}
			expense_types={expense_types}
			expense_groupings={expense_groupings}
			providers={providers}
			payment_types={payment_types}
		/>
	);
};

export default MobileExpenseFormPage;
